import React, { Component } from "react";
import _ from "lodash";
// Externals
import PropTypes from "prop-types";
import classNames from "classnames";

// Material helpers
import { withStyles } from "@material-ui/core";

// Material components
import { Grid, Typography, Paper, Collapse, CardActions, IconButton } from "@material-ui/core";
import { Remove, Add } from "@material-ui/icons";

// Shared components
import { ConnectionCard } from "../../components";

// Component styles
import styles from "./styles";

class ConnectionsList extends Component {
  state = { collapsed: this.props.collapsed };
  renderConnections() {
    const { connections, showBadge, enabled } = this.props;

    const connectionsTemp = this.props.connections.map(item => item.connectorName);
    const enabledTemp = this.props.enabled.map(item => item.connectorName);
    const both = connectionsTemp.filter(item => enabledTemp.includes(item));
    let isEnabled = {};

    connections.map(item => {
      if (both.includes(item.connectorName)) {
        isEnabled[item.connectorName] = true;
      }
    });

    const conns = _.filter(connections, connection => {
      return connection.visible;
    });

    // if (conns.length === 0) {
    //   return <Typography variant="h6">There are no connections available</Typography>;
    // }

    return (
      <Grid className={this.props.classes.listOfConnectors} container spacing={3}>
        {conns.map((connection, index) => (
          <Grid item key={connection.connectionName + index.toString()}>
            <ConnectionCard
              connection={connection}
              enabled={_.get(isEnabled, connection.connectionName, false)}
              editable={
                ["faq-dev", "faq"].indexOf(connection.connectionName) >= 0 && !showBadge
                  ? _.filter(enabled, c => {
                      return c.connectionName === connection.connectionName;
                    })
                  : false
              }
              showBadge={showBadge}
            />
          </Grid>
        ))}
      </Grid>
    );
  }

  toggleConnectors = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  render() {
    const { classes, className } = this.props;
    const rootClassName = classNames(classes.root, className);

    return (
      <div className={rootClassName}>
        <Paper className={classes.row} elevation={0}>
          <CardActions className={classes.listHeader} onClick={this.toggleConnectors}>
            {/*<div className={classes.listHeaderContainer}>*/}
            <IconButton aria-expanded={true} aria-label="Show more">
              {!this.state.collapsed ? <Remove /> : <Add />}
            </IconButton>

            <Typography variant="h3">
              <span className={classes.noSelect}>{this.props.name}</span>
            </Typography>

            <Typography className={classes.numberOfConnections}>
              <span>
                {this.props.connections.length > 0
                  ? this.props.connections.length === 1
                    ? `${this.props.connections.length} item`
                    : `${this.props.connections.length} items`
                  : "No connections available"}
              </span>
            </Typography>
            {/*</div>*/}
          </CardActions>
          <Collapse in={!this.state.collapsed} timeout="auto" unmountOnExit>
            <Grid item xs={12} className={classes.rowContent}>
              {this.renderConnections()}
            </Grid>
          </Collapse>
        </Paper>
      </div>
    );
  }
}

ConnectionsList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  connections: PropTypes.array.isRequired,
  showBadge: PropTypes.bool
};

export default withStyles(styles)(ConnectionsList);
